var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "template-icon",
    d: "M14.6,4H3.4A1.335,1.335,0,0,0,2,5.25v7.5A1.335,1.335,0,0,0,3.4,14H14.6A1.335,1.335,0,0,0,16,12.75V5.25A1.335,1.335,0,0,0,14.6,4Zm0,8.75H3.4V5.25H14.6Zm-9.8-5H6.2V9H4.8Zm0,2.5h5.6V11.5H4.8Zm7,0h1.4V11.5H11.8ZM7.6,7.75h5.6V9H7.6Z",
    transform: "translate(-2 -4)",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.cac3c641.svg";
export { ForwardRef as ReactComponent };